import { __extends } from "tslib";
import * as React from 'react';
import { Animated, StyleSheet, View } from 'react-native';
import Icon, { isValidIcon, isEqualIcon } from './Icon';
var CrossFadeIcon = /** @class */function (_super) {
  __extends(CrossFadeIcon, _super);
  function CrossFadeIcon() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      currentIcon: _this.props.source,
      previousIcon: null,
      fade: new Animated.Value(1)
    };
    return _this;
  }
  CrossFadeIcon.getDerivedStateFromProps = function (nextProps, nextState) {
    if (nextState.currentIcon === nextProps.source) {
      return null;
    }
    return {
      currentIcon: nextProps.source,
      previousIcon: nextState.currentIcon
    };
  };
  CrossFadeIcon.prototype.componentDidUpdate = function (_, prevState) {
    var previousIcon = this.state.previousIcon;
    var scale = this.props.theme.animation.scale;
    if (!isValidIcon(previousIcon) || isEqualIcon(previousIcon, prevState.previousIcon)) {
      return;
    }
    this.state.fade.setValue(1);
    Animated.timing(this.state.fade, {
      duration: scale * 200,
      toValue: 0,
      useNativeDriver: false
    }).start();
  };
  CrossFadeIcon.prototype.render = function () {
    var _a = this.props,
      color = _a.color,
      size = _a.size;
    var opacityPrev = this.state.fade;
    var opacityNext = this.state.previousIcon ? this.state.fade.interpolate({
      inputRange: [0, 1],
      outputRange: [1, 0]
    }) : 1;
    var rotatePrev = this.state.fade.interpolate({
      inputRange: [0, 1],
      outputRange: ['-90deg', '0deg']
    });
    var rotateNext = this.state.previousIcon ? this.state.fade.interpolate({
      inputRange: [0, 1],
      outputRange: ['0deg', '-180deg']
    }) : '0deg';
    return /*#__PURE__*/React.createElement(View, {
      style: [styles.content, {
        height: size,
        width: size
      }]
    }, this.state.previousIcon ? (/*#__PURE__*/React.createElement(Animated.View, {
      style: [styles.icon, {
        opacity: opacityPrev,
        transform: [{
          rotate: rotatePrev
        }]
      }]
    }, /*#__PURE__*/React.createElement(Icon, {
      source: this.state.previousIcon,
      size: size,
      color: color
    }))) : null, /*#__PURE__*/React.createElement(Animated.View, {
      style: [styles.icon, {
        opacity: opacityNext,
        transform: [{
          rotate: rotateNext
        }]
      }]
    }, /*#__PURE__*/React.createElement(Icon, {
      source: this.state.currentIcon,
      size: size,
      color: color
    })));
  };
  return CrossFadeIcon;
}(React.Component);
export default CrossFadeIcon;
var styles = StyleSheet.create({
  content: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  icon: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  }
});